import WsService from "../WsService";
import AgentInfo from "../../domain/AgentInfo"
import AgentTransactionInfoForDate from "../../domain/AgentTransactionInfoForDate";
import AgentReferralLink from "../../domain/AgentReferralLink";

export default class AgentInfoService {

    static retrieveAgentInfo(agentId) {

        let endpoint = "/admin/agent-info?agent-id=" + agentId;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new AgentInfo(response);
            },
            response => {
                return response;
            }
        )

    }

    static retrieveAgentReferralLink() {
        let endpoint = "/registrations/registration-referral/generate-referral-link"

        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new AgentReferralLink(response)
            },
            response => {
                return response
            }
        )
    }


    static retrieveAgentInfoForTheMonth(agentId, date) {

        let endpoint = "/admin/agent-info/transactions?agent-id=" + agentId + "&date=" + date;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new AgentTransactionInfoForDate(response);
            },
            response => {
                return response;
            }
        )

    }

}